export var colors = {
    typography: {
        primary: '#fff',
        secondary: '#8d8d94',
        link: '#0084ff',
    },
    app: {
        background: '#000',
        background1: '#1c1c1e',
        background2: '#2c2c2e',
        background3: '#3a3a3a',
        divider: '#2f2f32',
    },
    entityHeader: { icon: '#2f2f32' },
    // Modal
    modal: {
        background: '#1c1c1e',
        toolbarBackground: '#171719',
        disabledToolbarButton: '#484849',
        activeToolbarButton: '#0a84ff',
    },
    page: {
        // This seems to be a semi transparent color so it is somewhat variable
        toolbarBackground: '#121212',
    },
    list: {
        background: '#2c2c2e',
    },
    // Accents
    accent: '#0a84ff',
    darkAccent: '#115ba5',
    orangeAccent: '#ff453a',
    text: {
        primary: '#ffffff',
        secondary: '#8f8f94',
    },
    searchInput: {
        background: '#2b2b2c',
        icon: '#9e9ea5',
        placeholderText: '#8e8e93',
        text: '#ffffff',
    },
    // Inputs
    placeholderText: '#66666a',
    labelText: '#ffffff',
};
//# sourceMappingURL=colors.js.map